"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kebabToPascal = exports.makeSearchStrings = exports.makeSearchString = exports.removeAccents = void 0;
var COMBINING_CHARACTERS_REGEX = new RegExp("[\u0300-\u036F]", 'g');
var WHITESPACE_REGEX = new RegExp('[ ]+', 'g');

var removeAccents = function removeAccents(str) {
  return (str || '').normalize('NFD').replace(COMBINING_CHARACTERS_REGEX, '');
};

exports.removeAccents = removeAccents;

var makeSearchString = function makeSearchString(str) {
  return removeAccents(str).toLowerCase().trim();
};

exports.makeSearchString = makeSearchString;

var makeSearchStrings = function makeSearchStrings(str) {
  return (str || '').split(WHITESPACE_REGEX).map(makeSearchString);
};

exports.makeSearchStrings = makeSearchStrings;

var kebabToPascal = function kebabToPascal() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var arr = str.split('-');
  var capital = arr.map(function (item, index) {
    return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
  });
  return capital.join('');
};

exports.kebabToPascal = kebabToPascal;